import { GridFilterInputValue, GridFilterItem, GridFilterOperator } from "@mui/x-data-grid-pro";

import { operator } from "types";

export const getGridArrayOperators = (): GridFilterOperator[] => [
  // Equality
  {
    label: "contains",
    value: operator.arrayContains,
    getApplyFilterFn: (filterItem: GridFilterItem) => {
      return (params) => {
        if (!filterItem.value) {
          return true;
        }

        if (!params) {
          return false;
        }

        return (params as string[]).some((value) =>
          value.toLowerCase().includes((filterItem.value as string).toLowerCase())
        );
      };
    },
    InputComponent: GridFilterInputValue
  },
  {
    label: "is empty",
    value: operator.arrayIsEmpty,
    getApplyFilterFn: () => {
      return (params) => {
        return !params || params.length === 0;
      };
    }
  }
];
